import { useMutation, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Autocomplete from '../../../../components/Autocomplete';
import { messagesIdPage } from '../../../../constants/pagesRoutesContants';
import OptionInterface from '../../../../interfaces/OptionInterface';
import { fetchContactLawyer } from '../../../../services/contactLawyerService';
import { fetchConversationByRecipientId } from '../../../../services/messageService';
import UserType from '../../../../types/UserType';

interface Props {
    setRecipient: (recipient: OptionInterface) => void;
}

function ContactForm(props: Props) {
    const { setRecipient } = props;
    const navigate = useNavigate();
    const [recipientData, setRecipientData] = useState<OptionInterface | null>(
        null
    );

    const { mutate } = useMutation({
        mutationFn: async (id: string) => {
            const result = await fetchConversationByRecipientId(id);
            if (result.data?.id != null) {
                navigate(messagesIdPage.path + result.data.id);
            } else {
                if (recipientData) {
                    setRecipient(recipientData);
                }
            }
        },
    });

    const handleSelect = (value: OptionInterface | undefined) => {
        if (value?.id) {
            mutate(value?.id);
            setRecipientData(value);
        }
    };

    const { isPending: isPendingContact, data: contacts } = useQuery({
        queryKey: ['contacts'],
        queryFn: async () => {
            try {
                const { data } = await fetchContactLawyer();
                return data || [];
            } catch (error) {
                console.error(error);
            }
            return [];
        },
    });

    const optionsContacts: OptionInterface[] = contacts?.map(
        (contact: UserType) => {
            return {
                label: contact.firstName + ' ' + contact.lastName,
                name: contact.firstName + ' ' + contact.lastName,
                id: contact.id,
                value: contact.id,
            };
        }
    );

    return (
        <div>
            <Autocomplete
                label="Destinataire"
                options={optionsContacts}
                onOptionClick={handleSelect}
                isDataLoading={isPendingContact}
            />
        </div>
    );
}

export default ContactForm;
